export class PaymentType {
  constructor(paymentType = {}) {
    this.key = paymentType.key;
    this.name = paymentType.name;
  }
}
